export const formatter = (number: number, curr: string) => {
  try {
    const currency = new Intl.NumberFormat("de-DE", {
      style: "currency",
      currency: curr || "EUR",
      minimumFractionDigits: 0,
    });
    return currency.format(Math.floor(number)).toString().replace(".", ",");
  } catch (e) {
    const currency = new Intl.NumberFormat("de-DE", {
      style: "currency",
      currency: "EUR",
      minimumFractionDigits: 0,
    });
    return currency.format(Math.floor(number)).toString().replace(".", ",");
  }
};
